import { Grid, GridProps } from '@mui/material';
import React, { FC } from 'react';

export const DpGridCardFrame: FC<GridProps> = ({ children, ...props }) => (
	<Grid container columnSpacing={'20px'} {...props}>
		{children}
	</Grid>
);
